import React from 'react';
import { Box, Typography } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import { styled } from '@material-ui/core/styles';

export type MarkType = 'question' | 'answer';

export interface MarkIconProps {
  markType: MarkType;
}

export const MarkIcon: React.FC<MarkIconProps> = React.memo(
  (props: MarkIconProps) => {
    const markContext = (() => {
      switch (props.markType) {
        case 'question':
          return { color: '#0EC6BD', character: 'Q' };
        case 'answer':
          return { color: '#FCA106', character: 'A' };
        default:
          return { color: '#0EC6BD', character: 'Q' };
      }
    })();

    const Component = styled('span')(({ theme }) => ({
      backgroundColor: markContext.color,
      borderRadius: '4px',
      color: '#ffffff !important',
      display: 'flex',
      fontSize: '28px !important',
      lineHeight: '34px !important',
      justifyContent: 'center',
      alignItems: 'center',
      height: '40px',
      width: '40px',
    }));

    return (
      <Icon
        component={() => (
          <Typography component={Component}>{markContext.character}</Typography>
        )}
      />
    );
  },
);

export interface UploadedIconProps {
  className?: string;
}
export const UploadedIcon: React.FC<UploadedIconProps> = ({
  className = '',
}) => {
  const StyledBox = styled(Box)({
    width: '44px',
    height: '44px',
    backgroundColor: '#EDEFF3',
    border: '1px solid #C2CAD8',
    borderRadius: '2px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& svg': {
      width: '44px',
      height: '44px',
      color: '#C2CAD8',
    },
  });

  const imgSrc = `${process.env.PUBLIC_URL}/images/visitor.svg`;
  const imgAlt = 'file uploaded';

  return (
    <StyledBox className={className}>
      <img src={imgSrc} alt={imgAlt} />
    </StyledBox>
  );
};
